import { render } from "./calendarPrenotazione.vue?vue&type=template&id=6dc463cc&ts=true"
import script from "./calendarPrenotazione.vue?vue&type=script&lang=ts"
export * from "./calendarPrenotazione.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__